import sensors from 'sensors';
import Exposure from 'Exposure';
import Cookies from"js-cookie";
//将sensors挂载到window对象上，方便全局调用
window.sensors = sensors;
//使用曝光采集插件
sensors.use(Exposure, {
    area_rate: 0.5, 
    stay_duration: 2, 
    repeated: false 
});
//初始化神策
sensors.init({
    name: 'sensors',
    server_url: 'https://datasink.daveimia.com/sa?project=production',
    heatmap:{
        clickmap:'default',//not_collect
        scroll_delay_time: 2000, 
        scroll_notice_map:'default'
    },
    show_log:false,
    // web_url:'https://sensorsweb.daveimia.com/',
    use_client_time:true,
    send_type:'beacon',
    show_log: false,
})
//判断是否有用户直接进入结账页，如果有调整匿名ID为之前的匿名ID
const _sa_AnonymousID = Cookies.get('_sa_AnonymousID')
if(_sa_AnonymousID){
    sensors.identify(_sa_AnonymousID);
    Cookies.remove('_sa_AnonymousID');
}

//注册公共属性
sensors.registerPage({
    p_platform_type:detectDeviceType(),
    p_is_login:theme.is_login||false,
    p_site_platform:"shopify",
    p_shop_id:theme.id,
    p_site_uid:theme.customer_id||"",
    p_thrid_fbp:Cookies.get('_fbp')||"",
    p_thrid_ga:Cookies.get('_ga')||"",
    p_referrer:document.referrer||"",
});
setTimeout(()=>{
    let _fbp = Cookies.get('_fbp')||"";
    let _ga = Cookies.get('_ga')||"";
    if(_fbp || _ga){
        let userData = {};
        if(_fbp) userData.u_thrid_fbp = _fbp;
        if(_ga) userData.u_thrid_ga = _ga;
        sensors.setProfile(userData);
    }
},1000)

//用于采集 $pageview 事件
sensors.quick('autoTrack');

//判断是否登录，如果登录了且当前用户和之前登录用户不同则关联用户
if(theme.is_login){
    var oldIdentities = sensors.store.getIdentities();
    if(oldIdentities.$identity_login_id != theme.customer_email.toLowerCase()) {
        sensors.login(theme.customer_email.toLowerCase());
    }
}

window.addEventListener('DOMContentLoaded', function () {
    // //点击事件采集
    // $('body').on( 'click', '[data-sensors-click-event-name][data-sensors_click]', function (event) {
    //     console.log('-------------slot click -----------')
    //     if(this.hasAttribute('data-stop_propagation')) {
    //         event.stopPropagation();
    //     };
    //     handleSensorsEvent(this, 'click');
    // });
   document.body.addEventListener('click', function (event) {
        // 用 closest 找到匹配 selector 的元素（就是 jQuery delegate 里 this 的语义）
        var el = event.target.closest('[data-sensors-click-event-name][data-sensors_click]');
        if (!el) return;  // 点击的元素不在匹配范围内，直接跳过

        console.log('-------------slot click -----------', event);
        if (el.hasAttribute('data-stop_propagation')) {
            event.stopPropagation();
        }
        handleSensorsEvent(el, 'click');
    });
    
    // 输入事件，按下回车时触发
    $('body').on('keypress', '[data-sensors-click-event-name][data-sensors_enter]', function (e) {
        if (e.which != 13) return;
        handleSensorsEvent(this, 'input');
    });
    // 输入事件，输入框值改变时触发
    $('body').on('change', '[data-sensors-click-event-name][data-sensors_change]', function () {
        handleSensorsEvent(this, 'input');
    });

    function handleSensorsEvent(element, eventType) {
        console.log('element',element)
        var sensorsClickData = getSensorsClickAttributes(element);
        var eventName = $(element).data('sensors-click-event-name');
        if(eventType !== 'click'&&eventName != 'cart_edit'){
            sensorsClickData.extra_data = $(element).val();
        }
        if(eventName == 'buy_now_click'){//立即购买
            if(sensorsClickData.module_name=="pdp_buy"||sensorsClickData.module_name=="quick_buy"){//详情页和快速加购购买时额外添加变体id，数量，价格
                const formEle = $(element).closest('form.product-form');
                const formData = new FormData(formEle[0]);
                const entryData = Object.fromEntries(formData.entries());
                sensorsClickData.variant_id = entryData.id;
                sensorsClickData.quantity = entryData.quantity;
                sensorsClickData.price = formEle.find('.sensors_variant_price').val();
            }else{//购物车购买时额外添加购物车信息
                sensorsClickData.cart_value = $(element).find('.sensors-total_cart_price').val();
                sensorsClickData.cart_items_count = document.querySelector("cart-link items-count").innerText;
            }
        }else if(eventName == 'cart_edit'){//购物车内删除商品时去掉数量
            if(sensorsClickData.operation_type!="delete"){
                sensorsClickData.operation_after_quantity = $(element).closest('quantity-input')[0].value;
            }
        }else if(sensorsClickData.variant_id&&$(element).closest('product-single').length>0){//详情页点击事件时，修改变体id，sku，价格
            setTimeout(()=>{
                var addFormEl = $(element).closest('product-single').find('.add-to-cart-form');
                sensorsClickData.variant_id = addFormEl.find('input[name="id"]').val();
                sensorsClickData.shop_sku = addFormEl.find('.sensors_variant_sku').val();
                sensorsClickData.price = addFormEl.find('.sensors_variant_price').val();
                sensors.track(eventName, sensorsClickData);
            })
            return;
        }else if(eventName == 'quick_buy_click'){//快速加购点击事件时，记录点击位置
            if(sensorsClickData.module_name){
                sessionStorage.setItem('quick_buy_click_slot_id',sensorsClickData.module_name);
                if(sensorsClickData.rank){
                    sessionStorage.setItem('quick_buy_click_rank',sensorsClickData.rank)
                }else{
                    sessionStorage.removeItem('quick_buy_click_rank');
                }
            }else{
                sessionStorage.removeItem('quick_buy_click_slot_id');
                sessionStorage.removeItem('quick_buy_click_rank');
            }
        }
        sensors.track(eventName, sensorsClickData);
    }

    // ---------------------单独事件处理开始----------------------
    //提交按钮点击事件，包含头部及搜索结果页搜索按钮
    $('body').on('click', '[data-sensors-click-to-input]', function () {
        var eventElement = $(this).closest('form').find('[data-sensors-input-to-click]')[0];
        handleSensorsEvent(eventElement, 'input');
    })
    //加购事件统一处理
    $('body').on('submit', 'form.add-to-cart-form', function (e) {
        var sensorsClickData = {},eventName = "",spec_arr = [];
        //获取表单信息
        const formData = new FormData(e.target);
        const entryData = Object.fromEntries(formData.entries());
        sensorsClickData.variant_id = entryData.id;
        sensorsClickData.quantity = entryData.quantity;
        //处理通用信息
        $(this).find('.sensors-data-input').each(function() {
            var dataKey = $(this).data('key');
            if(dataKey == "event-name"){
                eventName = $(this).val();
            }else if(dataKey == "sku_name"){
                //将sku名称拆分，并处理成神策需要的格式
                var keyArr = $(this).val().split('/');
                var valueArr = $(this).siblings('.sensors_variant_title').val().split('/');
                valueArr.forEach((sku, index) => {
                    spec_arr.push({
                        property: keyArr[index],
                        value: $.trim(sku)
                    });
                });
            }else{
                sensorsClickData[dataKey] = $(this).val();
            }
        })
        //处理超100sku插件的情况
        Object.keys(entryData).forEach(key => {
            if(key.startsWith("properties")){
                const match = key.match(/\[(.*?)\]/);
                if (match) {
                    spec_arr.push({
                        property: match[1],
                        value: entryData[key]
                    })
                }
            }
        })
        if(sensorsClickData.module_name == 'quick_buy_add'){
            if(sessionStorage.getItem('quick_buy_click_slot_id')) sensorsClickData.slot_id = sessionStorage.getItem('quick_buy_click_slot_id');
            if(sessionStorage.getItem('quick_buy_click_rank')) sensorsClickData.rank = sessionStorage.getItem('quick_buy_click_rank');
        }
        
        sensorsClickData.spec_arr = spec_arr;
        sensors.track(eventName, sensorsClickData);
    })
    //个人中心页面，line连接按钮点击事件
    $('body').on('click', '.socialplus-association-button', function () {
        sensors.track("account_icon_click", {
            extra_data:$(this).text(),
            module_name:"line"
        });
    })

    //组合购加购按钮点击事件
    document.body.addEventListener('click', function (e) {
        const btn = e.target.closest('.rbu-sb-container .rbu-sb-btn');
        if (!btn) return;
        const parentSlot = btn.closest('[data-sensors-exposure-property-slot_id]');
        if(parentSlot){
            const slotId = parentSlot.getAttribute('data-sensors-exposure-property-slot_id');
            const rank = parentSlot.getAttribute('data-sensors-exposure-property-rank');
            if(slotId) sessionStorage.setItem('rbu_slot_id', slotId);
            if(rank) sessionStorage.setItem('rbu_rank', rank);
        }else{
            sessionStorage.removeItem('rbu_slot_id');
            sessionStorage.removeItem('rbu_rank');
        }
    }, true)
    // ---------------------单独事件处理结束----------------------
})

window.addEventListener('on:cart:add', function(event){
    console.log('-------e', event)
    const detail = event.detail;
    console.log('----------detail?.items?.[0]?.module_name',detail?.items?.[0]?.module_name )
    // 组合购加购： 
     if (detail?.items?.[0]?.module_name === 'veimia_bundle_discount'|| detail?.items?.[0]?.module_name === 'veimia_bundle_combo_discount') {
        // sensors.track("veimia_bundle_discount_add_cart", {
        //     extra_data:$(this).text(),
        //     module_name:"line"
        // });
        detail.items.forEach(item => {
                var skuArr = item.variant_options || {};
                window.sensors && sensors.track('add_to_cart', {
                    product_page_id: item.product_id,
                    product_vendor: item.vendor,
                    product_title: item.product_title,
                    variant_id: item.variant_id,
                    quantity: item.quantity,
                    price: item.original_line_price,
                    currency_code: "JPY",
                    module_name: item.module_name,
                    spec_arr:Object.values(skuArr).map(item => { return { value: item.trim() } })
                });
            })
     };
})

/**
 * 检测设备类型函数
 * 根据用户代理和屏幕宽度判断设备类型
 * @returns {string} 返回设备类型： 'mobile-web' 或 'pc-web'
 */
function detectDeviceType() {
    // 获取用户代理字符串，优先使用 navigator.userAgent，其次为 navigator.vendor 或 window.opera
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 优先使用用户代理判断移动设备
    if (/iphone|ipad|ipod|android|blackberry|iemobile/i.test(userAgent)) {
        return 'mobile-web';
    }

    const screenWidth = window.innerWidth;
    // 如果屏幕宽度小于某个阈值（例如768px），则认为是移动设备（平板或小屏幕电脑）
    if (screenWidth < 768) {
        return 'mobile-web';
    } else {
        return 'pc-web';
    }
}

/**
 * 获取点击元素上的神策属性
 * 根据用户代理和屏幕宽度判断设备类型
 * @returns {Object} 返回神策属性对象data-sensors-click-property-*：*匹配的内容为key，属性值为value
 */
function getSensorsClickAttributes(element) {
    const attributes = {};
    const regex = /^data-sensors-click-property-(.*)$/i;
    for (let i = 0; i < element.attributes.length; i++) {
        const attr = element.attributes[i];
        const match = attr.name.match(regex);
        if (match) {
            attributes[match[1]] = attr.value;
        }
    }
    return attributes;
}